import { render } from "./RoleRange.vue?vue&type=template&id=73a23ab2"
import script from "./RoleRange.vue?vue&type=script&lang=js"
export * from "./RoleRange.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__